<div class="page-wrapper" *ngIf="summaryData">
  <div class="summary-card">

    <!-- Header -->
    <div class="card-header-block">
      <div class="header-left">
        <img src="logo-login.svg" alt="aInstitute Logo" class="card-logo" />
        <div class="progress-wrap">
          <div class="progress-bar">
            <div class="progress-fill" style="width: 100%"></div>
          </div>
          <span class="progress-label">Step 4 of 4 — Final Review</span>
        </div>
      </div>
      <div class="exec-badge">
        Exec Code: <strong>{{ summaryData.executiveCode }}</strong>
      </div>
    </div>

    <!-- Page Title -->
    <div class="summary-header">
      <h1 class="summary-title">Registration Summary</h1>
      <p class="summary-subtitle">
        Please review all details carefully before confirming your subscription.
      </p>
    </div>

    <div class="summary-body">

      <!-- ════ ADMINISTRATOR ════ -->
      <section class="info-section">
        <h2 class="section-heading">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
            <path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Administrator Details
        </h2>
        <div class="info-grid">
          <div class="info-item span-2">
            <span class="info-label">Full Name</span>
            <span class="info-value fw-bold">
              {{ summaryData.admin.firstName }}
              {{ summaryData.admin.middleName }}
              {{ summaryData.admin.lastName }}
            </span>
          </div>
          <div class="info-item">
            <span class="info-label">Date of Birth</span>
            <span class="info-value">{{ summaryData.admin.dob }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Gender</span>
            <span class="info-value">{{ summaryData.admin.gender }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Email Address</span>
            <span class="info-value">{{ summaryData.admin.email }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Mobile Number</span>
            <span class="info-value">{{ summaryData.admin.mobile }}</span>
          </div>
        </div>
      </section>

      <!-- ════ INSTITUTE ════ -->
      <section class="info-section">
        <h2 class="section-heading">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
            <path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0H5m14 0h-5m-9 0H3m2 0h5m0 0V9a1 1 0 011-1h2a1 1 0 011 1v12m-4 0h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Institute Details
        </h2>
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">Institute Name</span>
            <span class="info-value fw-bold">{{ summaryData.institute.name }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Official Email</span>
            <span class="info-value">{{ summaryData.institute.email }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Website</span>
            <a [href]="'https://' + summaryData.institute.website" target="_blank" class="info-link">
              {{ summaryData.institute.website }}
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
                <path d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </a>
          </div>
          <div class="info-item">
            <span class="info-label">Accreditation</span>
            <span class="info-value">{{ summaryData.institute.accreditation }}</span>
          </div>
          <div class="info-item span-2">
            <span class="info-label">
              Address
              <span class="location-type-tag">{{ summaryData.institute.location.locationType.locationTypeName }}</span>
            </span>
            <span class="info-value">{{ summaryData.institute.location | formatAddress }}</span>
          </div>
          <div class="info-item span-2">
            <span class="info-label">Description</span>
            <span class="info-value">
              @if (summaryData.institute.description) {
                {{ summaryData.institute.description }}
              } @else {
                <span class="text-muted">Not provided</span>
              }
            </span>
          </div>
        </div>
      </section>

      <!-- ════ SUBSCRIPTION PLAN ════ -->
      <section class="plan-highlight">
        <div class="plan-highlight-left">
          <span class="plan-label">Selected Plan</span>
          <h3 class="plan-name">{{ summaryData.subscription.plan }}</h3>
          <span class="plan-billing">Billed annually per student</span>
        </div>
        <div class="plan-price-block">
          <span class="plan-price-original" *ngIf="discountAmount">{{ summaryData.subscription.price }}</span>
          <span class="plan-price" *ngIf="!discountAmount">{{ summaryData.subscription.price }}</span>
          <span class="plan-price plan-price-final" *ngIf="discountAmount">₹{{ finalPrice }}/Student/Year</span>
          <span class="plan-discount-badge" *ngIf="discountAmount">-₹{{ discountAmount }} off</span>
        </div>
      </section>

      <!-- ════ DISCOUNT CODE ════ -->
      <section class="discount-section">
        <label class="field-label" for="discountCode">Discount Code</label>
        <div class="discount-row">
          <input
            id="discountCode"
            class="field-input"
            type="text"
            placeholder="Enter promo code"
            [(ngModel)]="discountCode"
            [disabled]="!!discountAmount"
          />
          <button
            type="button"
            class="btn-apply"
            (click)="applyDiscount()"
            [disabled]="!discountCode.trim() || isApplyingDiscount || !!discountAmount"
          >
            {{ isApplyingDiscount ? 'Applying…' : (discountAmount ? 'Applied' : 'Apply') }}
          </button>
        </div>
        <div class="discount-success" *ngIf="discountAmount">
          <span>Discount of ₹{{ discountAmount }} applied successfully.</span>
          <button type="button" class="btn-remove-discount" (click)="removeDiscount()">Remove</button>
        </div>
        <p class="discount-error" *ngIf="discountError">{{ discountError }}</p>
      </section>

      <!-- ════ TERMS ════ -->
      <section class="terms-section">
        <label class="terms-check-label">
          <input type="checkbox" class="terms-checkbox" [(ngModel)]="termsAccepted" />
          <span class="terms-text">
            I agree to the <a target="_blank" href="https://ainstitute.cloud/terms-and-conditions" class="terms-link">Terms and Conditions</a> and
            <a target="_blank" href="https://ainstitute.cloud/privacy-policy" class="terms-link">Privacy Policy</a> for the educational institution.
          </span>
        </label>
      </section>

    </div>

    <!-- ════ SUBMIT ERROR ════ -->
    <div class="submit-error-block" *ngIf="submitError">
      <p class="submit-error-message">{{ submitError }}</p>
      <ul class="submit-error-list" *ngIf="submitErrors.length">
        <li *ngFor="let e of submitErrors">{{ e.msg }}</li>
      </ul>
    </div>

    <!-- Footer Actions -->
    <div class="form-footer">
      <button type="button" class="btn-back" (click)="backToPricing()">
        <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
          <path d="M13 8H3M7 4l-4 4 4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Back to Pricing
      </button>
      <button
        type="button"
        class="btn-confirm"
        [disabled]="!termsAccepted || isSubmitting"
        (click)="confirmSubscription()"
      >
        <span *ngIf="!isSubmitting">
          Confirm Subscription
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <span *ngIf="isSubmitting">Submitting…</span>
      </button>
    </div>

  </div>
</div>
